import React from 'react';
import { ClassNames } from '@emotion/core';

import {
  ModalDialogRoot,
  ModalDialogHeader,
  ModalDialogBody,
  ModalDialogFooter,
  Text,
} from '@zapier/design-system';

import AsyncButton from 'app/developer-v3/components/AsyncButton';
import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';

type Props = {
  isSaving: boolean;
  onConfirm: () => void;
};

const TermsOnly = ({ isSaving, onConfirm }: Props) => {
  return (
    <ClassNames>
      {({ css }) => (
        <ModalDialogRoot
          isOpen
          isDismissable={false}
          aria-label="Terms changed"
          dialogClassName={css({
            maxWidth: '550px',
          })}
        >
          <ModalDialogHeader>
            Zapier Platform Agreement terms have changed
          </ModalDialogHeader>
          <ModalDialogBody>
            <Text tag="p" type="Body1">
              We recently updated the{' '}
              <Link href={`${PLATFORM_MARKETING_BASE_URL}/tos`} target="_blank">
                Zapier Platform Agreement
              </Link>{' '}
              terms. By continuing to use the Zapier Platform, you agree to
              these updated terms.
            </Text>
          </ModalDialogBody>
          <ModalDialogFooter>
            <AsyncButton
              isDisabled={isSaving}
              isWorking={isSaving}
              onPress={onConfirm}
            >
              Continue
            </AsyncButton>
          </ModalDialogFooter>
        </ModalDialogRoot>
      )}
    </ClassNames>
  );
};

export default TermsOnly;
